import { render, staticRenderFns } from "./SMSOnboardingStepBusiness.vue?vue&type=template&id=56da9d88&scoped=true"
import script from "./SMSOnboardingStepBusiness.vue?vue&type=script&lang=js"
export * from "./SMSOnboardingStepBusiness.vue?vue&type=script&lang=js"
import style0 from "./SMSOnboardingStepBusiness.vue?vue&type=style&index=0&id=56da9d88&prod&lang=scss&scoped=true"
import style1 from "./SMSOnboardingStepBusiness.vue?vue&type=style&index=1&id=56da9d88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da9d88",
  null
  
)

export default component.exports